import {
  axiosAssessmentInstance,
  axiosArisChatInstance,
} from "../AxiosConfiguration";

export const getSessions = async () => {
  try {
    const response = await axiosAssessmentInstance.get(
      "/api/coaching/get_sessions"
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const startCoach = async (session_id) => {
  try {
    const response = await axiosAssessmentInstance.post(
      `/api/coaching/start_coach?session_id=${session_id}`
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const getChat = async (data) => {
  try {
    const response = await axiosAssessmentInstance.put(
      "/api/coaching/get_chat",
      data
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const scheduleSession = async (data) => {
  try {
    const response = await axiosAssessmentInstance.post(
      "/api/coaching/schedule/coach",
      data
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const cancelSession = async (session_id) => {
  try {
    const response = await axiosAssessmentInstance.post(
      `/api/coaching/cancel_session?session_id=${session_id}`
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const rescheduleSession = async (data) => {
  try {
    const response = await axiosAssessmentInstance.put(
      "/api/coaching/update_coach_schedule",
      data
    );
    return response.data;
  } catch (error) {
    return error;
  }
};

export const fetchGroupInstructions = async (id) => {
  try {
    const response = await axiosAssessmentInstance.get(
      `/api/coaching/instructions/group?relation_id=${id}`
    );
    return response.data;
  } catch (error) {
    if (error.status === 500) {
      return {
        message: "Server error. Please try again later.",
      };
    } else {
      return {
        message: "Something went wrong. Please try again later.",
      };
    }
  }
};

export const fetchHistoryQuery = async (id, currentDateTime) => {
  try {
    const response = await axiosArisChatInstance.post(
      `/ARIS/coaching/starter/voice?user_id=${id}&date_time=${currentDateTime}&callback_url=${process.env.REACT_APP_BASE_URL_ASSESSMENT}/api/coaching/coaching_data?user_id=${id}`
    );
    return response.data;
  } catch (error) {
    if (error.status === 500) {
      return {
        message: "Server error. Please try again later.",
      };
    } else {
      return {
        message: "Something went wrong. Please try again later.",
      };
    }
  }
};

export const fetchPrivateInstructions = async () => {
  try {
    const response = await axiosAssessmentInstance.get(
      "/api/coaching/v2/instructions/private"
    );
    return response.data;
  } catch (error) {
    if (error.status === 500) {
      return {
        message: "Server error. Please try again later.",
      };
    } else {
      return {
        message: "Something went wrong. Please try again later.",
      };
    }
  }
};

export const endSession = async (
  session_id,
) => {
  try {
    await axiosArisChatInstance.post(`/ARIS/v2/chat/end-session`, {
      session_id,
      module: "VOICE",
    });
  } catch (error) {
    console.error(error);
  }
};

export const fetchHistory = async () => {
  try {
    const response = await axiosArisChatInstance.get(
      "/ARIS/v2/chat/voice-coaching-history"
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

/**
 * Fetch the authenticated user's recent resumable individual voice
 * conversations (newest first). Used to power the "Resume conversation" flow.
 * See backend contract: GET /ARIS/voice/conversations/recent.
 * @param {number} [limit=20] Max conversations to return (1-30).
 * @returns {Promise<{success: boolean, conversations: Array, total_count: number}>}
 */
export const getResumableConversations = async (limit = 20) => {
  try {
    const safeLimit = Math.min(Math.max(Number(limit) || 20, 1), 30);
    const response = await axiosArisChatInstance.get(
      `/ARIS/voice/conversations/recent?limit=${safeLimit}`
    );
    return response.data;
  } catch (error) {
    console.error(error);
    return { success: false, conversations: [], total_count: 0 };
  }
};

export const getHabits = async () => {
  try {
    const response = await axiosAssessmentInstance.get(
      "/api/coaching/get_habits"
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const updateHabits = async () => {
  try {
    const response = await axiosAssessmentInstance.get(
      "/api/coaching/update_habits"
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const getElements = async (user_id) => {
  try {
    const response = await axiosArisChatInstance.get(
      `/ARIS/tools/get_elements_data/${user_id}?callback_url=${process.env.REACT_APP_BASE_URL_ASSESSMENT}/api/status/fetch/user/elements?user_id=${user_id}`,
      { user_id: user_id }
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const getElementsGroup = async (user_id1, user_id2) => {
  try {
    const response = await axiosArisChatInstance.get(
      `/ARIS/tools/get_elements_data/group/${user_id1}/${user_id2}?user_id1=${user_id1}&user_id2=${user_id2}`,
      {
        user_id1: user_id1,
        user_id2: user_id2,
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const roleplay = async (
  user_name,
  role_id,
  chat_history,
  topic,
  situation,
  reason,
  relationship
) => {
  try {
    const response = await axiosArisChatInstance.post(`/ARIS/tools/roleplay`, {
      user_name,
      role_id,
      chat_history,
      topic,
      situation,
      reason,
      relationship,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const getPronun = async (_id, user_id) => {
  try {
    const response = await axiosArisChatInstance.get(
      `/ARIS/coaching/pronun_fetch/${user_id}?_id=${_id}&user_id=${user_id}`
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const savePronun = async (_id, pronunciation, user_id) => {
  try {
    const response = await axiosArisChatInstance.post(
      `/ARIS/coaching/pronun_add?user_id=${user_id}&pronun=${encodeURIComponent(
        pronunciation
      )}&_id=${_id}`
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const getAboutYou = async () => {
  try {
    const response = await axiosArisChatInstance.get(
      "/ARIS/tools/about_aris/voice"
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const getSubmitFeedback = async (userID, feedback) => {
  try {
    const response = await axiosArisChatInstance.post("/ARIS/tools/feedback", {
      user_id: userID,
      feedback: feedback,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const getAdviceFromHelper = async (
  user_name,
  problem,
  persons_involved,
  your_doubt,
  your_understanding
) => {
  try {
    const response = await axiosArisChatInstance.post(
      "/ARIS/tools/guide_aris",
      {
        user_name: user_name,
        problem: problem,
        persons_involved: persons_involved,
        your_doubt: your_doubt,
        your_understanding: your_understanding,
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const getRelationData = async (user_id) => {
  try {
    const callbackUrl = encodeURIComponent(
      `${process.env.REACT_APP_BASE_URL_ASSESSMENT}/api/relation/relation/get/data?user_profile_id=${user_id}`
    );

    const response = await axiosArisChatInstance.get(
      `/ARIS/tools/relations/${user_id}?callback_url=${callbackUrl}`
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const resumeCoaching = async () => {
  try {
    const response = await axiosAssessmentInstance.get(
      "/api/coaching/resume/coach"
    );
    return response.data;
  } catch (error) {
    if (error.status === 500) {
      return {
        message: "Server error. Please try again later.",
      };
    } else {
      return {
        message: "Something went wrong. Please try again later.",
      };
    }
  }
};

export const getTranscript = async (data) => {
  try {
    const response = await axiosArisChatInstance.post(
      "/ARIS/transcript_audio",
      data,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const analyzeAudio = async (formData, names) => {
  try {
    const response = await axiosArisChatInstance.post(
      `/ARIS/analyze_audio?allowed_names=${names.join("&allowed_names=")}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const handleStoreVoiceEmbedding = async (blob, userid) => {
  try {
    const formData = new FormData();
    formData.append("file", blob, "recording.webm");
    formData.append("userid", userid);
    const response = await axiosArisChatInstance.post(
      "/ARIS/store-voice-embedding",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const checkUser = async (relation_id) => {
  try {
    const response = await axiosAssessmentInstance.get(`/api/coaching/check-user?relation_id=${relation_id}`)
    return response.data.payload
  } catch (error) {
    throw error;
  }
}

export const checkUserActivation = async () => {
  try {
    // Get the current user ID from cookies
    const profile = JSON.parse(localStorage.getItem("profile"));
    const userId = profile._id;
    if (!userId) {
      console.error('User ID not found in cookies');
      throw new Error('User ID not found');
    }

    // Using the mock API URL provided with POST request and user_id
    const response = await axiosArisChatInstance.get(`/ARIS/voice/activation/status?user_id=${userId}`);
    return response.data.response;
  } catch (error) {
    console.error('Error checking user activation status:', error);
    throw error;
  }
}

// Batch activation status check for multiple users
// GET /ARIS/v2/chat/activation/status/batch?user_ids=<id>&user_ids=<id2>
export const checkUsersActivationBatch = async (userIds = []) => {
  try {
    if (!Array.isArray(userIds) || userIds.length === 0) return {};
    // Build query string with repeated user_ids keys to match server expectation
    const query = userIds.map((id) => `user_ids=${encodeURIComponent(id)}`).join('&');
    const response = await axiosArisChatInstance.get(`/ARIS/v2/chat/activation/status/batch?${query}`);
    // Expected shape: { success: true, data: { [userId]: boolean }, count: number }
    return response?.data?.data || {};
  } catch (error) {
    console.error('Error checking batch activation status:', error);
    // On error, return empty map so UI can gracefully disable unknowns
    return {};
  }
}

// ============================================
// Coaching Topics API
// ============================================

// Cache key prefix for coaching topics
// Bumped to v2 so older caches (which may predate the navigation `action` field
// added with the Your Elements rollout) are invalidated on first load.
const COACHING_TOPICS_CACHE_KEY = 'coaching_topics_cache_v2';
const COACHING_TOPICS_CACHE_TTL = 24 * 60 * 60 * 1000; // 24 hours in milliseconds

/**
 * Get cached coaching topics from localStorage
 * @param {string} cacheKey - The cache key
 * @returns {Object|null} - Cached data or null if not found/expired
 */
const getCachedCoachingTopics = (cacheKey) => {
  try {
    const cached = localStorage.getItem(cacheKey);
    if (!cached) return null;
    
    const { data, timestamp } = JSON.parse(cached);
    const now = Date.now();
    
    // Check if cache is expired
    if (now - timestamp > COACHING_TOPICS_CACHE_TTL) {
      localStorage.removeItem(cacheKey);
      return null;
    }
    
    return data;
  } catch (error) {
    console.warn('Error reading coaching topics cache:', error);
    return null;
  }
};

/**
 * Set coaching topics cache in localStorage
 * @param {string} cacheKey - The cache key
 * @param {Object} data - The data to cache
 */
const setCachedCoachingTopics = (cacheKey, data) => {
  try {
    const cacheEntry = {
      data,
      timestamp: Date.now()
    };
    localStorage.setItem(cacheKey, JSON.stringify(cacheEntry));
  } catch (error) {
    console.warn('Error setting coaching topics cache:', error);
  }
};

/**
 * Get coaching topics for the current user
 * @param {string} platform - 'web' or 'mobile' (default: 'web')
 * @param {string} sessionType - 'voice' or 'keyboard' (optional)
 * @param {boolean} forceRefresh - Force refresh from API (default: false)
 * @returns {Promise<{categories: Array, total_topics: number}>}
 */
export const getCoachingTopics = async (platform = 'web', sessionType = null, forceRefresh = false) => {
  // Build cache key based on params
  const cacheKey = `${COACHING_TOPICS_CACHE_KEY}_${platform}_${sessionType || 'all'}`;
  
  // Check cache first (unless force refresh)
  if (!forceRefresh) {
    const cached = getCachedCoachingTopics(cacheKey);
    if (cached) {
      return cached;
    }
  }
  
  try {
    let url = `/api/v3/coaching-topics?platform=${platform}`;
    if (sessionType) {
      url += `&session_type=${sessionType}`;
    }
    const response = await axiosAssessmentInstance.get(url);
    const data = response.data?.payload || { categories: [], total_topics: 0 };
    
    // Cache the response
    setCachedCoachingTopics(cacheKey, data);
    
    return data;
  } catch (error) {
    console.error('Error fetching coaching topics:', error);
    throw error;
  }
};

/**
 * Clear coaching topics cache (useful when topics are updated)
 * @param {string} platform - Optional platform to clear specific cache
 * @param {string} sessionType - Optional session type to clear specific cache
 */
export const clearCoachingTopicsCache = (platform = null, sessionType = null) => {
  try {
    if (platform && sessionType !== undefined) {
      // Clear specific cache
      const cacheKey = `${COACHING_TOPICS_CACHE_KEY}_${platform}_${sessionType || 'all'}`;
      localStorage.removeItem(cacheKey);
    } else {
      // Clear all coaching topics caches
      const keys = Object.keys(localStorage).filter(key => key.startsWith(COACHING_TOPICS_CACHE_KEY));
      keys.forEach(key => localStorage.removeItem(key));
    }
  } catch (error) {
    console.warn('Error clearing coaching topics cache:', error);
  }
};

/**
 * Pin or unpin a coaching topic
 * @param {string} topicId - UUID of the topic
 * @param {boolean} pinned - true to pin, false to unpin
 * @returns {Promise<{topic_id: string, is_pinned: boolean, message: string}>}
 */
export const pinCoachingTopic = async (topicId, pinned) => {
  try {
    const response = await axiosAssessmentInstance.post('/api/v3/coaching-topics/pin', {
      topic_id: topicId,
      pinned: pinned,
    });
    return response.data?.payload || {};
  } catch (error) {
    console.error('Error pinning/unpinning topic:', error);
    throw error;
  }
};